import React from 'react'
import ReservationSegmentCardFolios from '../ReservationSegmentCard/tabs/ReservationSegmentCardFolios'
import ModalButtons from '../ModalButtons/ModalButtons'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import CheckoutWarning from './CheckoutWarning'
// import BootstrapDialog from "../../libraries/bootstrap-dialog"
import ReactDOM from 'react-dom';
import ReactPortalsRoot from '../ReactPortalsRoot/ReactPortalsRoot';
import ModalWarning from '../ModalWarning/ModalWarning';
import numeral from 'numeral';
//import I18n from "i18n-js/index.js.erb"

export default class ReservationSegmentCheckOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayWarningModal: false,
      loading: false,
      errors: [],
      balance_amount: this.props.reservation_segment.balance_amount ? this.props.reservation_segment.balance_amount : null,
    };

    this.renderCheckoutWarning = this.renderCheckoutWarning.bind(this)
    this.ignoreFoliosAndCheckOut = this.ignoreFoliosAndCheckOut.bind(this)
    this.onPaymentTaken = this.onPaymentTaken.bind(this);

  };

  componentDidMount(){
    $(window).on('refresh_data_table.datatable', () => {
      this.onPaymentTaken();
    });
  };

  render() {
    // console.log("this.props", this.props);
    var buttons = this.setButtons();

    return(
      <div>
        {this.state.errors && this.state.errors.length ? <div className="alert alert-danger">• {this.state.errors[0]}</div> : null}
        <ReservationSegmentCardFolios {...this.props} check_out={true} print_button={true} />
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        <LoadingSpinner show={this.state.loading} />
        {this.renderPaymentTotalBanner()}

        {this.renderWarning()}
      </div>
    );
  };

  setButtons() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('check_out'),
        button_classes: ['primary'],
        onClick: function(e) {
          self.checkOut()
          return false;

        }
      }
    ];
    return buttons
  };

  checkOut() {
    var self = this;
    this.setState({loading: true});

    $.ajax({
      type: 'POST',
      url: `/admin/reservation_segments/${self.props.reservation_segment.id}/process_check_out`,
      data: {
        reservation_segment:{

        },
      }
    }).done((data) => {
      if (data.warning){
          // this.renderWarning()
        self.setState({ displayWarningModal: true, loading: false });
      } else if (data.errors && data.errors.length) {

        self.setState({errors: data.errors, loading: false});
      } else {
        if(parent && parent.refresh_data) {
          parent.refresh_data(I18n.t("checked_out"));
        }
        if(parent && parent.hide_modal) {
          parent.hide_modal();
        };

      };
    });
  };

  renderCheckoutWarning() {
    return(
      <CheckoutWarning />
    )
  }

  renderWarning() {
    var self = this;

    return(
      <div>
        {
          self.state.displayWarningModal
            ?
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("folios_out_of_balance")}
                body={this.renderCheckoutWarning()}
                CancelSubmit
                onSubmit={this.ignoreFoliosAndCheckOut}
                onCancel={() => this.setState({ displayWarningModal: false})}

              />
            ]}
            wrapperClassNames="ModalWarningWrapper"

          />
            :
          null
        }

      </div>
    )


    // BootstrapDialog.show({
    //   title: I18n.t('update_folio_items'),
    //   onshown:  (dialog) =>{
    //     ReactDOM.render(
    //       <CheckoutWarning />,
    //       document.getElementById('checkout-warning')
    //     );
    //   },
    //   // size: 'size-wide',
    //   message: '<div id="checkout-warning"></div>',
    //   buttons: [
    //     {
    //       label: I18n.t('cancel'),
    //       cssClass: 'btn btn-secondary',
    //       action: (dialog) => {
    //         dialog.close();
    //       }
    //     },
    //     {
    //       label: I18n.t('check_out'),
    //       cssClass: 'btn btn-primary',
    //       action: (dialog) =>{
    //         dialog.close()
    //         this.ignoreFoliosAndCheckOut()
    //       }
    //     }
    //   ]
    // });
  };

  renderPaymentTotalBanner() {
    if (this.state.balance_amount && this.state.balance_amount != 0) {
      return (
        <div className="accommodations-price-footer">

          <p className="lead" style={{ marginBottom: 0, display: 'inline-block', marginRight: '20px' }}>
            <label style={{ marginBottom: 0 }}>{I18n.t('balance_due')}:</label>&nbsp;
            {this.formatCurrency(this.state.balance_amount)}
          </p>


        </div>
      );
    } else {
      null
    }
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  onPaymentTaken(){
    this.setState({ loading: true });
    $.ajax({
      type: 'GET',
      url: `/admin/reservation_segments/${this.props.reservation_segment.id}/check_out_update`,
    }).done((data) => {
      this.setState({
        balance_amount: data.balance_amount,
        loading: false,
      });
    });
  };


  ignoreFoliosAndCheckOut(){
    $.ajax({
      type: 'POST',
      url: `/admin/reservation_segments/${this.props.reservation_segment.id}/process_check_out`,
      data: {
        ignore_folios: true,
        reservation_segment: {

        },
      }
    }).done((data) => {
      if (data.errors && data.errors.length) {

        this.setState({ errors: data.errors, loading: false });
      } else {
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t("checked_out"));
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        };

      };
    });
  };
};
